import request from '@/utils/request'


export function checkLogin(data){
    return request({
        url:'/account/login',
        method:'post',
        data:data
    })
}
export function getPartAllList(data){
    return request({
        url:'/department/selectAllList',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}
export function getPartList(data){
    return request({
        url:'/department/selectAll',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}

export function addPart(data){
    return request({
        url:'/department/add',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}


export function updatePart(data){
    return request({
        url:'/department/update',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}

export function delPart(data){
    return request({
        url:'/department/delete',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:{
            id:data
        }
    })
}

//人员

export function getStaffList(data){
    return request({
        url:'/staff/selectAll',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}

export function addStaff(data){
    return request({
        url:'/staff/add',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}

export function updateStaff(data){
    return request({
        url:'/staff/update',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}

export function delStaff(data){
    return request({
        url:'/staff/delete',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:{
            id:data
        }
    })
}

//添加分管理员
export function addAdmin(data){
    return request({
        url:'/account/add',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}
//删除分管理员
export function delAdmin(data){
    return request({
        url:'/account/delete',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:{
            id:data
        }
    })
}

export function getAdminList(data){
    return request({
        url:'/account/list',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}

export function getOrgansList(data){
    return request({
        url:'/department/listOrgans',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}
export function updateSort(data){
    return request({
        url:'/department/updateSort',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}
//解绑
export function unbindStaff(data){
    return request({
        url:'/staff/unbind',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:{
            id:data
        }
    })
}
//修改密码

export function changePW(data){
    return request({
        url:'/account/changePW',
        headers: {
            'token':localStorage.getItem('token'),
        },
        method:'post',
        data:data
    })
}
